import { RadioButton } from 'dw-au-react-components';
import React, { useEffect, useState } from 'react';
import { EditIcon } from '../../svg';
import CartHeader from '../ShoppingCart/CartHeader';
import MemberAddressLayout from './MemberAddressLayout';

function MemberSelectShipping({
	setStep,
	userData,
	handleMemberShipping,
	handleMakeDefaultAddress,
	message,
}) {
	let shippingAddress = userData?.trustedDetails?.shippingAddress;

	const [radioSelection, setRadioSelection] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		getDefaultShipping();
	}, []);

	// Get Default Shipping
	const getDefaultShipping = () => {
		let filteredCard = shippingAddress?.filter((card) => {
			return card.isDefaultDelivery;
		});
		if (filteredCard?.length > 0) {
			setRadioSelection(filteredCard[0]?.addressId);
		}
	};

	const onRadioChange = (e) => {
		setRadioSelection(e.target.value);
		handleShippingDefault(e.target.value);
	};

	// Get filtered Shipping address
	const getShippingObject = (addressId) => {
		let filteredAddress = shippingAddress?.filter((address) => {
			return address.addressId === addressId;
		});
		return filteredAddress[0];
	};

	const handleShippingDefault = (addressId = radioSelection) => {
		if (addressId) {
			handleMakeDefaultAddress(addressId);
			setError(null);
		} else {
			setError('Select a Address');
		}
	};

	return (
		<div>
			<CartHeader title='Shipping Address' />
			{error && <div className='mb-20 alert alert-danger'>{error}</div>}
			{shippingAddress.length > 0 && (
				<>
					<div className='subtitle mb-16 lower roboto'>Ship to</div>
					<div className='text_big mb-16 text-dark-medium'>
						Select another saved address to change your default shipping address
						for all online orders.
					</div>
					<div className='mb-40'>
						{shippingAddress
							// ?.sort((a, b) =>
							// 	a.isDefaultDelivery > b.isDefaultDelivery
							// 		? -1
							// 		: a.isDefaultDelivery < b.isDefaultDelivery
							// 		? 1
							// 		: 0
							// )
							.map((filteredAddress, index) => {
								return (
									<div className=' mb-20' key={index}>
										<div className='d-flex justify-content-between align-items-center'>
											<RadioButton
												cypressClass='card-radio'
												value={filteredAddress.addressId}
												isChecked={radioSelection === filteredAddress.addressId}
												onChange={onRadioChange}
												className='mb-0'
											/>
											<MemberAddressLayout
												filteredAddress={filteredAddress}
												setRadioSelection={setRadioSelection}
												handleShippingDefault={handleShippingDefault}
											/>
											<div
												className='cursor-pointer'
												onClick={() => handleMemberShipping(filteredAddress, 6)}
											>
												<EditIcon />
											</div>
										</div>
										{message?.class === 'alert-success' &&
											radioSelection === filteredAddress.addressId && (
												<div className='mt-10 mb-40 text-green'>
													{message?.message}
												</div>
											)}
									</div>
								);
							})}
					</div>
					{/* <div
						className='text-red mb-40 cursor-pointer d-inline-block'
						onClick={handleShippingDefault}
					>
						Change Default
					</div> */}
				</>
			)}
			<div
				type='submit'
				className='btn btn-primary font-weight-bold dmlp__btn w-100 mb-20'
				onClick={() => handleMemberShipping('', 6)}
			>
				Add New Address
			</div>
			<div
				className='btn btn-outline-secondary btn-block'
				onClick={() => {
					setStep(5);
				}}
			>
				Back to Order Confirmation
			</div>
		</div>
	);
}

export default MemberSelectShipping;
